import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import Projects from '../../components/Projects'
import parallastic from '../../utils/parallastic'
import './EbaySocial.sass'

export class EbaySocial extends React.Component {
  static propTypes = {
    pageName: PropTypes.string
  }

  static defaultProps = {
    pageName: 'EbaySocial'
  }

  componentDidMount = () => {
    const p = parallastic(this.scrollTarget())
    p.addToggler(this.refs.laptop, 'into-view', 0.40)
    p.addToggler(this.refs.mobile, 'into-view', 0.40)
    p.addToggler(this.refs.watch, 'into-view', 0.40)
    p.addToggler(this.refs.speaking, 'into-view', 0.40)

    p.addToggler(this.refs.section, 'into-view', 0.25)
  }

  scrollTarget = () =>
    this.refs.ebaySocial ? this.refs.ebaySocial.parentNode.parentNode : false

  render = () => {
    return (
      <div className="page" id={this.props.pageName} ref="ebaySocial">
        <section id="intro">
          <div className="container">
            <h1 className="page-title">
              <FormattedMessage id="ebaySocial.page-title" />
            </h1>
            <div className="intro-text">
              <p>
                <FormattedMessage id="ebaySocial.intro-text-1" />
              </p>
            </div>
          </div>
        </section>
        <section className="features" id="feature-1">
          <div className="left">
            <h2 className="title">
              <FormattedMessage id="ebaySocial.feature-1-title" />
            </h2>
            <p>
              <FormattedMessage id="ebaySocial.feature-1-text-1" />
            </p>
            <p>
              <FormattedMessage id="ebaySocial.feature-1-text-2" />
            </p>
          </div>
          <div className="right" ref="laptop" />
        </section>
        <section className="features" id="feature-2">
          <div className="left">
            <h2 className="title">
              <FormattedMessage id="ebaySocial.feature-2-title" />
            </h2>
            <p>
              <FormattedMessage id="ebaySocial.feature-2-text" />
            </p>
          </div>
          <div className="right" ref="mobile" />
        </section>
        <section className="features" id="feature-3" ref="section">
          <div className="container">
            <div className="left">
              <div className="feature-3-icon" ref="watch" />
              <h3 className="feature-3-title-1">
                <FormattedMessage id="ebaySocial.feature-3-title-1" />
              </h3>
              <p>
                <FormattedMessage id="ebaySocial.feature-3-text-1" />
              </p>
            </div>
            <div className="right">
              <div className="feature-3-icon" ref="speaking" />
              <h3 className="feature-3-title-2">
                <FormattedMessage id="ebaySocial.feature-3-title-2" />
              </h3>
              <p>
                <FormattedMessage id="ebaySocial.feature-3-text-2" />
              </p>
            </div>
          </div>
        </section>
        <section className="features" id="feature-4" />
        <Projects prev="fundivisa" next="unleash" />
      </div>
    )
  }
}

export default EbaySocial
